import {ADD_FAVORITE, DELETE_FAVORITE, GET_FAVORITE, GET_FAVORITE_EVENTS} from '../actionTypes';
import api from '../../api/api';
import {UPDATE_FAVORITES} from '../mutationTypes';
import {ERROR_CODE} from '@/const';

export default {
  [ADD_FAVORITE]: async ({dispatch}, {
    id,
    type,
  }) => {
    await api.favorites.add_favorite({
      id,
      type,
    }).then(() => dispatch(GET_FAVORITE)).catch((err) => {
      if (err.status !== ERROR_CODE.UNAUTHENTICATED) {
        dispatch(GET_FAVORITE);
      }
    });
  },
  [DELETE_FAVORITE]: async ({dispatch}, {
    id,
  }) => {
    await api.favorites.delete_favorite({
      id,
    }).then(() => dispatch(GET_FAVORITE)).catch((err) => {
      if (err.status !== ERROR_CODE.UNAUTHENTICATED) {
        dispatch(GET_FAVORITE);
      }
    });
  },
  [GET_FAVORITE]: async ({commit, getters}) => {
    if (!getters.isLogged) return Promise.reject(new Error('user must be logged in'));
    let res = null;
    try {
      res = await api.favorites.get_favorites();
      commit(UPDATE_FAVORITES, res);
    } catch (e) {
      console.warn('GET_FAVORITE', e);
    }
    return res;
  },
  [GET_FAVORITE_EVENTS]: async (_,
      {
        abortSignal: token,
        ...params
      } = {}) => {
    return api.favorites.get_favorite_events(params, token);
  },
};
